import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class GeneratedLeadReportCountries extends Vue {
  @Prop({ type: Array, required: true }) private readonly countries!: string[];

  private expandList = false;
  private limit = 10;

  private get showedCountries() {
    return !this.expandList
      ? this.countries.slice(0, this.limit)
      : this.countries;
  }

  private toggleExpandList() {
    this.expandList = !this.expandList;
  }
}
